import ApplicationModel from '../../../../../shared/models/applications/api/ApplicationModel';
import ApplicationLayoutModel from '../../../../../shared/models/applications/api/ApplicationLayoutModel';

export const getLocationCategoryScope = <T extends Pick<ApplicationModel, 'id' | 'allowsTemplating'>>(
    apps: T[],
    layout: ApplicationLayoutModel | null,
    categoryId: string,
    selectedIds: Set<string>
): { apps: T[]; selectedAppIds: Set<string> } => {
    let categoryApps = apps;
    if (categoryId) {
        const categoryIds = new Set(layout?.groups.find(group => group.id === categoryId)?.appIds || []);
        const groupedIds = new Set((layout?.groups || []).reduce((ids, group) => ids.concat(group.appIds), [] as string[]));
        categoryApps = layout ? apps.filter(app => !app.allowsTemplating && (categoryId === 'ungrouped'
            ? !groupedIds.has(app.id)
            : categoryIds.has(app.id))) : [];
    }
    return {
        apps: categoryApps,
        selectedAppIds: new Set(categoryApps.filter(app => !!app.id && selectedIds.has(app.id)).map(app => app.id))
    };
};
